import React from 'react'
import { Link } from 'react-static'

import '../styles/not-found.scss'

const NotFound = () => (
  <div className="not-found">
  	<p>Page Not Found.</p>
		<Link to="/" replace>
			<button className="secondary-button">Go Home</button>
		</Link>
  </div>
)

export default NotFound



// WEBPACK FOOTER //
// /opt/build/repo/src/components/NotFound.js